function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M136.755 96.585C136.755 117.729 119.863 134.869 99.0266 134.869C78.1899 134.869 61.2983 117.729 61.2983 96.585",
  stroke: "#20205E",
  strokeWidth: 10.6838
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M78.9048 103.394C85.2598 110.45 102.164 120.329 118.941 103.394",
  stroke: "#20205E",
  strokeWidth: 7.65625
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M163.475 92.9853L163.475 140.181L156.57 140.181L156.57 92.9853C151.085 91.0027 147.045 84.5955 147.045 76.9068C147.02 67.6466 152.848 60.1514 159.998 60.1514C167.197 60.1514 173.024 67.6466 173 76.9068C173 84.5955 168.96 91.0027 163.475 92.9853Z",
  fill: "#20205E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M42.6212 140.03L35.3877 140.03L35.3621 89.969L34.2847 89.9171C33.3373 89.9205 32.3985 89.7344 31.5225 89.3695C30.6465 89.0046 29.8506 88.4681 29.1806 87.791C28.5106 87.1138 27.9798 86.3094 27.6188 85.4241C27.2578 84.5387 27.0736 83.5899 27.077 82.6323L27 60.0518L31.7453 60.0259L31.7966 76.877L36.6702 76.8251L36.6446 60L41.3643 60L41.3386 76.8251L46.2122 76.877L46.2379 60L51.0089 60.0518L50.9319 82.6323C50.9319 86.6765 47.7 89.9431 43.7241 89.9171L42.6468 89.969L42.6212 140.03Z",
  fill: "#20205E"
});

var SvgNoLogoDown = function SvgNoLogoDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoLogoDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-logo-down.9988c486.svg";
export { ForwardRef as ReactComponent };